export function quoteRegExpSearchValue(value: string): string {
    return value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

export const validNameRuleRegExp = /^[0-9a-zA-Z-+_ .,]{0,60}$/;
